"use client";
import env from "@/env.mjs";
import useModal from "@/lib/hooks/useModal";
import algoliasearch from "algoliasearch/lite";
import { InstantSearch } from "react-instantsearch";

type Props = {
  children: React.ReactNode;
  modalAware?: boolean;
};

export const client = algoliasearch(
  env.NEXT_PUBLIC_ALGOLIA_APP_ID,
  env.NEXT_PUBLIC_ALGOLIA_SEARCH_TOKEN,
);

const AlgoliaSearchProvider = ({ children, modalAware = false }: Props) => {
  const { isOpen } = useModal("search", () => {}, false);

  if (modalAware && !isOpen) {
    return null;
  }

  return (
    <InstantSearch indexName="storyblok_journal" searchClient={client}>
      {children}
    </InstantSearch>
  );
};

export default AlgoliaSearchProvider;
